
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cv2zJawxdkss6pckdv3yG__S3_bMMsz2bUwWuUG6l_45W7gMeta } from "/usr/src/app/client/pages/cv.vue?macro=true";
import { default as index6cm98Z4ezJ6POKGgoqbai5pQYm3ui2EVgxTxZSgsr80Meta } from "/usr/src/app/client/pages/index.vue?macro=true";
import { default as skillstbBgh0tMsrspx4Gi6JQpxX04v6K9lssQoCYubMY76pMMeta } from "/usr/src/app/client/pages/skills.vue?macro=true";
import { default as contactsXFf3C5ypZTri4H_45mfUflK1sgq4ZM39TcaM5NNLgTuAgMeta } from "/usr/src/app/client/pages/contacts.vue?macro=true";
import { default as indexuFwocYbdVLrCXjhvgMQP7y9EOD0EU3ORNZSf7FUJmLcMeta } from "/usr/src/app/client/pages/git/index.vue?macro=true";
import { default as portfolioRndQsMCQAm0rfTFAI3VGCm0gezA1sE33xoIGilDlslMMeta } from "/usr/src/app/client/pages/portfolio.vue?macro=true";
import { default as _91repo_93n_U_45wySDHYhVCDlhJudZXAij1gxyFiC7eEkRh5HAst0Meta } from "/usr/src/app/client/pages/git/[repo].vue?macro=true";
import { default as indexEu6ha0br6A7w0fcPvqHFNrSh1hUZ3uHcKijneQFjog8Meta } from "/usr/src/app/client/pages/certs/index.vue?macro=true";
import { default as indexIUHsfkSYWv9VKaNBfMIebCXChGF_mAhSdHTTWCwabZ0Meta } from "/usr/src/app/client/pages/media/index.vue?macro=true";
import { default as indexdPOo9rZHVFYu4D04t6vqlCQc3iFOGBQlM636he__45BpEMeta } from "/usr/src/app/client/pages/assets/index.vue?macro=true";
import { default as _91cert_93Q6o1neugH_45fWoliWLtaMslJ04PTjzZEr9FZq6zIGNMEMeta } from "/usr/src/app/client/pages/certs/[cert].vue?macro=true";
import { default as _91media_93Z2ublEEerOvhYZnZXN2arFAsMAInxNxDYwHK2MSevWUMeta } from "/usr/src/app/client/pages/media/[media].vue?macro=true";
import { default as privacy_45policy0LdtOJckPvnAXtHOoJ_nd_450QaUFFgYgQDWEp5Q_jI4YMeta } from "/usr/src/app/client/pages/privacy-policy.vue?macro=true";
import { default as _91_46_46_46doc_93pPDkb1Wady6rTSQr_45UXiQg83xyNVaS5oiJEcubi1n8UMeta } from "/usr/src/app/client/pages/assets/docs/[...doc].vue?macro=true";
import { default as _91article_93prxB13EvjdlT5IqBeA2ZKwDP8FpZiqWDO4b1qxVYLOUMeta } from "/usr/src/app/client/pages/assets/articles/[article].vue?macro=true";
import { default as component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g } from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "cv___cn",
    path: "/cn/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___es",
    path: "/es/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___fr",
    path: "/fr/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___in",
    path: "/in/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___en",
    path: "/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___it",
    path: "/it/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___jp",
    path: "/jp/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "cv___ru",
    path: "/ru/cv",
    component: () => import("/usr/src/app/client/pages/cv.vue")
  },
  {
    name: "index___cn",
    path: "/cn",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___in",
    path: "/in",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___jp",
    path: "/jp",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/usr/src/app/client/pages/index.vue")
  },
  {
    name: "skills___cn",
    path: "/cn/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___es",
    path: "/es/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___fr",
    path: "/fr/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___in",
    path: "/in/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___en",
    path: "/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___it",
    path: "/it/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___jp",
    path: "/jp/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "skills___ru",
    path: "/ru/skills",
    component: () => import("/usr/src/app/client/pages/skills.vue")
  },
  {
    name: "contacts___cn",
    path: "/cn/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___es",
    path: "/es/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___fr",
    path: "/fr/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___in",
    path: "/in/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___en",
    path: "/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___it",
    path: "/it/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___jp",
    path: "/jp/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "contacts___ru",
    path: "/ru/contacts",
    component: () => import("/usr/src/app/client/pages/contacts.vue")
  },
  {
    name: "git___cn",
    path: "/cn/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___es",
    path: "/es/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___fr",
    path: "/fr/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___in",
    path: "/in/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___en",
    path: "/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___it",
    path: "/it/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___jp",
    path: "/jp/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "git___ru",
    path: "/ru/git",
    component: () => import("/usr/src/app/client/pages/git/index.vue")
  },
  {
    name: "portfolio___cn",
    path: "/cn/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___es",
    path: "/es/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___fr",
    path: "/fr/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___in",
    path: "/in/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___en",
    path: "/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___it",
    path: "/it/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___jp",
    path: "/jp/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "portfolio___ru",
    path: "/ru/portfolio",
    component: () => import("/usr/src/app/client/pages/portfolio.vue")
  },
  {
    name: "git-repo___cn",
    path: "/cn/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___es",
    path: "/es/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___fr",
    path: "/fr/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___in",
    path: "/in/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___en",
    path: "/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___it",
    path: "/it/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___jp",
    path: "/jp/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "git-repo___ru",
    path: "/ru/git/:repo()",
    component: () => import("/usr/src/app/client/pages/git/[repo].vue")
  },
  {
    name: "certs___cn",
    path: "/cn/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___es",
    path: "/es/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___fr",
    path: "/fr/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___in",
    path: "/in/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___en",
    path: "/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___it",
    path: "/it/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___jp",
    path: "/jp/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "certs___ru",
    path: "/ru/certs",
    component: () => import("/usr/src/app/client/pages/certs/index.vue")
  },
  {
    name: "media___cn",
    path: "/cn/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___es",
    path: "/es/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___fr",
    path: "/fr/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___in",
    path: "/in/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___en",
    path: "/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___it",
    path: "/it/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___jp",
    path: "/jp/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "media___ru",
    path: "/ru/media",
    component: () => import("/usr/src/app/client/pages/media/index.vue")
  },
  {
    name: "assets___cn",
    path: "/cn/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___es",
    path: "/es/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___fr",
    path: "/fr/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___in",
    path: "/in/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___en",
    path: "/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___it",
    path: "/it/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___jp",
    path: "/jp/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "assets___ru",
    path: "/ru/assets",
    component: () => import("/usr/src/app/client/pages/assets/index.vue")
  },
  {
    name: "certs-cert___cn",
    path: "/cn/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___es",
    path: "/es/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___fr",
    path: "/fr/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___in",
    path: "/in/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___en",
    path: "/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___it",
    path: "/it/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___jp",
    path: "/jp/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "certs-cert___ru",
    path: "/ru/certs/:cert()",
    component: () => import("/usr/src/app/client/pages/certs/[cert].vue")
  },
  {
    name: "media-media___cn",
    path: "/cn/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___es",
    path: "/es/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___fr",
    path: "/fr/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___in",
    path: "/in/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___en",
    path: "/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___it",
    path: "/it/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___jp",
    path: "/jp/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "media-media___ru",
    path: "/ru/media/:media()",
    component: () => import("/usr/src/app/client/pages/media/[media].vue")
  },
  {
    name: "privacy-policy___cn",
    path: "/cn/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___in",
    path: "/in/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___jp",
    path: "/jp/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    component: () => import("/usr/src/app/client/pages/privacy-policy.vue")
  },
  {
    name: "assets-docs-doc___cn",
    path: "/cn/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___es",
    path: "/es/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___fr",
    path: "/fr/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___in",
    path: "/in/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___en",
    path: "/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___it",
    path: "/it/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___jp",
    path: "/jp/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-docs-doc___ru",
    path: "/ru/assets/docs/:doc(.*)*",
    component: () => import("/usr/src/app/client/pages/assets/docs/[...doc].vue")
  },
  {
    name: "assets-articles-article___cn",
    path: "/cn/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___es",
    path: "/es/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___fr",
    path: "/fr/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___in",
    path: "/in/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___en",
    path: "/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___it",
    path: "/it/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___jp",
    path: "/jp/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: "assets-articles-article___ru",
    path: "/ru/assets/articles/:article()",
    component: () => import("/usr/src/app/client/pages/assets/articles/[article].vue")
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/cn/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/es/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/fr/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/in/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/it/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/jp/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/ru/vimeo",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/cn/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/es/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/fr/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/in/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/it/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/jp/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/ru/vimeo/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/cn/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/es/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/fr/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/in/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/it/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/jp/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/ru/docs",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/cn/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/es/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/fr/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/in/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/it/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/jp/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  },
  {
    name: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7gMeta?.name,
    path: "/ru/docs/:pathMatch(.*)",
    component: component_45stubc9szG_45YjbAoiKKcFtQOQm4g7F0TxAkZEOkA2BxBma7g
  }
]